// import React, { useEffect, useContext} from 'react';
// import { Alert, Button } from "antd";
// import { Field, ErrorMessage } from "formik";

import React, { useContext, useState } from "react";
import { Button, Upload, Form } from "antd";
import { Formik, Form as FormikForm, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ProductContext } from "context/ProductContext"; 
import axios from "axios"; 
import { DownloadOutlined, EditOutlined, FullscreenOutlined, DeleteOutlined } from "@ant-design/icons";

const Extra = ({ nextStep }) => {
  const { productData, setProductData, next } = useContext(ProductContext);
  const [previewUrl, setPreviewUrl] = useState(productData.imageUrl || "");
  const [loading, setLoading] = useState(false);

  // Validation schema using Yup
  const validationSchema = Yup.object().shape({
    logo: Yup.mixed()
      .required("Product logo is required")
      .test("fileType", "Only image files are allowed", (value) => {
        return value && value.type.startsWith("image/");
      }),
  });

  // Handle file change
  const handleFileChange = (file, setFieldValue) => {
    setFieldValue("logo", file);
    setPreviewUrl(URL.createObjectURL(file));
    return false; // Prevent automatic upload by Ant Design
  };

  // Handle form submission
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("logo", values.logo);
      formData.append("product_id", productData.product_id);

      // API call to upload product logo
      await axios.post("/v1/api/upload/v1/underwritter/product_logo", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      // Update product data with image URL
      setProductData({ ...productData, imageUrl: previewUrl });

      // Navigate to product view (assuming nextStep redirects or completes the wizard)
      nextStep();
    } catch (error) {
      console.error("Error uploading image:", error);
      alert("Failed to upload product logo. Please try again.");
    } finally {
      setLoading(false);
      setSubmitting(false);
    }
  };

  // Placeholder functions for image actions
  const handleDownload = () => console.log("Download image");
  const handleEdit = () => console.log("Edit image");
  const handleMaximize = () => console.log("Maximize image");
  const handleDelete = () => {
    setPreviewUrl("");
    setProductData({ ...productData, imageUrl: "" });
  };

  return (
    <div className="product-image">
      <h2 className="text-2xl font-bold mb-6">Product Image and Others</h2>
      <Formik
        initialValues={{
          logo: null,
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, setFieldValue }) => (
          <FormikForm>
            <div className="row">
              {/* File Upload */}
              <div className="col-md-8 mb-3">
                <Form.Item
                  label="Product Logo"
                  validateStatus={values.logo && !values.logo.type.startsWith("image/") ? "error" : ""}
                  help={<ErrorMessage name="logo" />}
                >
                  <Field name="logo">
                    {({ field }) => (
                      <Upload
                        beforeUpload={(file) => handleFileChange(file, setFieldValue)}
                        accept="image/*"
                        showUploadList={false}
                      >
                        <Button>Choose File</Button>
                      </Upload>
                    )}
                  </Field>
                  {values.logo && (
                    <div className="mt-2">
                      <span className="text-gray-600">{values.logo.name}</span>
                    </div>
                  )}
                </Form.Item>
              </div>

              {/* Image Preview */}
              {previewUrl && (
                <div className="col-md-4 mb-3">
                  <div className="relative">
                    <img
                      src={previewUrl}
                      alt="Product Logo Preview"
                      className="w-full h-48 object-cover rounded-lg"
                    />
                    <div className="absolute bottom-0 left-0 w-full p-4 flex justify-center">
                      <div className="flex space-x-2">
                        <Button
                          icon={<DownloadOutlined />}
                          onClick={handleDownload}
                          className="bg-gray-800 text-white"
                        />
                        <Button
                          icon={<EditOutlined />}
                          onClick={handleEdit}
                          className="bg-gray-800 text-white"
                        />
                        <Button
                          icon={<FullscreenOutlined />}
                          onClick={handleMaximize}
                          className="bg-gray-800 text-white"
                        />
                        <Button
                          icon={<DeleteOutlined />}
                          onClick={handleDelete}
                          className="bg-gray-800 text-white"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Submit Button */}
              <div className="col-12 mt-4">
                <Button type="primary"  htmlType="submit" loading={loading} block>
                  Complete
                </Button>
              </div>
            </div>
          </FormikForm>
        )}
      </Formik>
    </div>
  );
};

export default Extra;